import axios from 'axios';

import translateRules from 'actions/configuration/translateRules';

export default (async function(cdn, appId) {
  const response = await axios.get(`${cdn}/orgs/configs/chat/${appId}.json?q=${new Date().getTime()}`);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(`bad response code when fetching config: ${response.status}`);
  }
  response.data.rules = translateRules(response.data.rules); //until migration of old model happens

  return response.data;
});
